import React, { useState, useEffect, useCallback } from "react";
//utils
import { useHistory } from "react-router";
import { useData } from "../../../components/firebase/DataProvider";
import { firefunctions } from "../../../components/firebase/FirebaseProvider";
import currency from "../../../utils/currency";
//component
import Header from "../../../components/molecules/Header";
import Gap from "../../../components/Gap";
import PohonJaringan from "./pohonJaringan";
import UplineSaya from "./uplineSaya";
import useStyles from "./style";
import Harian from "./harian";
import Bulanan from "./bulanan";
import Tahunan from "./tahunan";
import Custom from "./custom";
import ListPendaftaran from "./listPendaftaran";
import TopSeller from "./topSeller";
import TopJaringan from "./topJaringan";
import TopProduk from "./topProduk";
import AllTransaksi from "./allTransaksi";
//material
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Button from "@material-ui/core/Button";
import Divider from "../../../components/Divider";
import { Skeleton } from "@material-ui/lab";
import CalonDialog from "./CalonDialog";

function SalesReport() {
  const [tabValue, setTabValue] = useState("harian");
  const [tabs, setTabs] = useState([
    {
      label: "Harian",
      value: "harian",
    },
    {
      label: "Bulanan",
      value: "bulanan",
    },
    {
      label: "Tahunan",
      value: "tahunan",
    },
    {
      label: "Custom",
      value: "custom",
    },
  ]);

  const handleChange = (event, value) => {
    setTabValue(value);
  };

  return (
    <Paper>
      <Tabs
        variant="scrollable"
        scrollButtons="on"
        textColor="primary"
        indicatorColor="primary"
        value={tabValue || "harian"}
        onChange={handleChange}
        variant="fullWidth"
      >
        {tabs.map((tab) => (
          <Tab fullWidth key={tab.value} label={tab.label} value={tab.value} />
        ))}
      </Tabs>
      <Harian value={tabValue} />
      <Bulanan value={tabValue} />
      <Tahunan value={tabValue} />
      <Custom value={tabValue} />
    </Paper>
  );
}

function Top() {
  const [tabValue, setTabValue] = useState("seller");
  const [tabs, setTabs] = useState([
    {
      label: "Top Seller",
      value: "seller",
    },
    {
      label: "Top Team",
      value: "jaringan",
    },
    {
      label: "Top Produk",
      value: "produk",
    },
  ]);

  const handleChange = (event, value) => {
    setTabValue(value);
  };

  return (
    <Paper>
      <Tabs
        variant="scrollable"
        scrollButtons="on"
        textColor="primary"
        indicatorColor="primary"
        value={tabValue || "harian"}
        onChange={handleChange}
        variant="fullWidth"
      >
        {tabs.map((tab) => (
          <Tab fullWidth key={tab.value} label={tab.label} value={tab.value} />
        ))}
      </Tabs>
      <TopSeller value={tabValue} />
      <TopJaringan value={tabValue} />
      <TopProduk value={tabValue} />
    </Paper>
  );
}

function JarinagnSaya() {
  const { profil } = useData();
  const classes = useStyles();
  const history = useHistory();
  const [transaksi, setTransaksi] = useState({});
  const [load, setLoad] = useState(false);
  const [dialogCalon, setDialogCalon] = useState(false);

  useEffect(() => {
    getTotalTransaksiSeller();
  }, []);

  const getTotalTransaksiSeller = useCallback(async () => {
    setLoad(true);
    const transaksi = firefunctions.httpsCallable("getTotalTransaksiSeller");
    const res = await transaksi({ user_id: profil.id });
    setTransaksi(res.data);
    setLoad(false);
  });

  return (
    <>
      <Header
        title="Team Saya"
        type="with-title"
        onClick={() => history.goBack()}
      />
      <div className={classes.hero}>
        <Gap height={20} />
        <div className={classes.wrapHeader}>
          <Typography className={classes.liquidBold}>
            Total Transaksi Refferal Saya
          </Typography>
          {load ? (
            <div
              style={{
                width: "25%",
                display: "inline-grid",
                marginLeft: "20px",
              }}
            >
              <Skeleton variant="text" />
            </div>
          ) : (
            <Typography className={classes.liquidBold}>
              {currency(transaksi?.total_transaksi_jaringan)}
            </Typography>
          )}
        </div>
      </div>
      {profil.tipe_akun !== "reseller" ? (
        <>
          <Gap height={18} />
          <Divider />
          <Gap height={17} />
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography className={classes.liquidBold}>
                Peta Team Saya
              </Typography>
              <Typography
                onClick={() => window.open("/datajaringan")}
                color="primary"
                style={{ fontSize: 14, marginRight: "1.5%" }}
              >
                Lihat Lainnya
              </Typography>
              {/* <Button
                style={{ marginRight: "20px" }}
                variant="outlined"
                size="small"
                color="primary"
                onClick={() => window.open("/datajaringan")}
              >
                Data Team
              </Button> */}
            </div>
            <PohonJaringan />
          </div>
          <Gap height={18} />
          <Divider />
          <Gap height={17} />
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {profil.tipe_akun === "agen" ? (
                <Typography className={classes.liquidBold}>
                  Calon Reseller
                </Typography>
              ) : profil.tipe_akun === "distributor" ? (
                <Typography className={classes.liquidBold}>
                  Calon Agen
                </Typography>
              ) : (
                <Typography className={classes.liquidBold}>
                  Calon Distributor
                </Typography>
              )}{" "}
              <Typography
                onClick={() => setDialogCalon(true)}
                color="primary"
                style={{ fontSize: 14, marginRight: "1.5%" }}
              >
                Lihat Lainnya
              </Typography>
            </div>
            <ListPendaftaran />
          </div>
        </>
      ) : null}
      <Gap height={18} />
      <Divider />
      <Gap height={17} />
      {profil.tipe_akun !== "mentorbisnis" ? (
        <div>
          <Typography className={classes.liquidBold}>Mitra Saya</Typography>
          <UplineSaya />
        </div>
      ) : null}
      <Gap height={18} />
      <Divider />
      <Gap height={17} />
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography className={classes.liquidBold}>Sales Report</Typography>
          <Button
            style={{ marginRight: "20px" }}
            variant="outlined"
            size="small"
            color="primary"
            onClick={() => window.open("/salesreport")}
          >
            Data Sales Report
          </Button>
        </div>
        <SalesReport />
      </div>
      <Gap height={18} />
      <Divider />
      <Gap height={17} />
      <div>
        {profil.tipe_akun !== "reseller" ? (
          <>
            <Typography className={classes.liquidBold}>
              Top Seller, Team & Produk
            </Typography>
            <Top />
          </>
        ) : (
          ""
        )}
      </div>{" "}
      <Gap height={18} />
      <Divider />
      <Gap height={17} />
      <div>
        <Typography className={classes.liquidBold}>All transaksi</Typography>
        <AllTransaksi />
      </div>
      <Gap height={18} />
      <Divider />
      <Gap height={5} />
      <CalonDialog
        open={dialogCalon}
        handleClose={() => {
          setDialogCalon(false);
        }}
      />
    </>
  );
}

export default JarinagnSaya;
